/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-escape */
import _ from 'lodash';

// PUT REGEX HERE
export const emailRegexAny = new RegExp(
  '[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+',
  'g'
);
export const emailRegex = new RegExp(
  '^[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+$'
);
const endsInAlmostCom = /\.co[^m]$/i;
const invalidEmailChars = /["(),:;<>]/;

export const digitsOnly = /^\d+$/;

export const restrictedChars = /[\{\}\<\>]+/;

// not a comprehensive list of nonprintable characters, will likely need to add characters as they pop up
/* eslint-disable-next-line no-control-regex */
export const nonprintableChars = /[\x00-\x1F\x7F]|\u200B|\u200C|\u200D|\uFEFF|\u2060/;

// END OF REGEX

export function isEmail(value: string): boolean {
  return !!(
    value &&
    emailRegex.test(value) &&
    !endsInAlmostCom.test(value) &&
    !invalidEmailChars.test(value)
  );
}

export function validateEmailList(emailList: string): string[] {
  return _.filter(_.map(_.split(emailList, ','), _.trim), (email) => !isEmail(email));
}

export function isGoodPassword(value: any) {
  return value && value.length >= 8;
}

export function validateFirstLastNameIfPresent(values: {
  firstName?: string;
  lastName?: string;
}): Dictionary<string> {
  const errors: Dictionary<string> = {};
  if (values.firstName && values.firstName.length > 255) {
    errors.firstName = 'Must be less than 255 characters';
  }
  if (values.lastName && values.lastName.length > 255) {
    errors.lastName = 'Must be less than 255 characters';
  }

  if (
    values.firstName &&
    (restrictedChars.test(values.firstName) || nonprintableChars.test(values.firstName))
  ) {
    errors.firstName = 'Please enter valid name';
  }

  if (
    values.lastName &&
    (restrictedChars.test(values.lastName) || nonprintableChars.test(values.lastName))
  ) {
    errors.lastName = 'Please enter valid name';
  }

  return errors;
}

export function isUrl(value: string): boolean {
  // https://www.regextester.com/94502
  return (
    !!/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.exec(
      value
    ) && !isEmail(value)
  );
}

export function isBirthdayDay(value: any) {
  return _.isNumber(_.toNumber(value)) && _.toNumber(value) >= 1 && _.toNumber(value) <= 31;
}

export function isBirthdayYear(value: any) {
  return _.isNumber(_.toNumber(value)) && _.toString(value).length === 4;
}

export function requireFields<T>(data: T, ...names: Array<keyof T & string>): Dictionary<string> {
  const errors: { [key: string]: string } = {};
  _.forEach(names, (name) => {
    if (!_.trim(_.toString(data[name]))) {
      errors[name] = 'Required';
    }
  });
  return errors;
}

export function isNumeric(value: string): boolean {
  return digitsOnly.test(value);
}
